import Model, { attr, belongsTo } from '@ember-data/model';
import type CompanyModel from 'garaje/models/company';
import type LocationModel from 'garaje/models/location';

enum TAKEOVER_TYPE {
  NORMAL = 'normal',
  CRITICAL = 'critical',
}

interface TakeoverMetadata {
  title: string;
  message: string;
  created_at: string;
  type?: TAKEOVER_TYPE;
}

export default class TakeoverModel extends Model {
  @attr() declare metadata: TakeoverMetadata;
  @attr('number') declare startAt: number;
  @attr('number') declare endAt?: number | null;
  @attr('boolean') declare active: boolean;

  @belongsTo('location', { async: true, inverse: null }) declare location: LocationModel;
  @belongsTo('company', { async: true, inverse: null }) declare company: CompanyModel;

  get isCritical(): boolean {
    return !this.metadata.type || this.metadata.type === TAKEOVER_TYPE.CRITICAL;
  }

  get isNormal(): boolean {
    return this.metadata.type === TAKEOVER_TYPE.NORMAL;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    takeover: TakeoverModel;
  }
}
